import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { RelativeTime } from '@core/models/date.model';
import { TrustpilotConfig } from '@core/models/trustpilot.model';
import { DateFormatterService } from '@core/services/date-formatter/date-formatter.service';

@Component({
  selector: 'app-product-close-details',
  templateUrl: './product-close-details.component.html',
  styleUrls: ['./product-close-details.component.scss']
})
export class ProductCloseDetailsComponent implements OnChanges {
  @Input() trustpilotConfig: TrustpilotConfig;
  @Input() endAt: Date;
  @Input() instantTypeText: string;

  timeVersion: RelativeTime;

  readonly relativeTime = RelativeTime;
  readonly hourFormat = 'h:mm a';

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.endAt) {
      this.timeVersion = DateFormatterService.convertToRelativeTime(this.endAt);
    }
  }
}
